import { isAxiosError } from 'axios';
import { Result, err, ok } from 'neverthrow';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore utils is in the parent dir
import axios from '@utils/axios';

import { ApiError } from 'types/api/ApiError';
import captureException from 'utils/captureException';

export interface ThreadSearchResult {
  threadID: string;
  threadItemID: string;
  threadReferences: string;
  inReplyTo: string[];
  recipients: string[];
  subject: string;
}

interface ThreadSearchResponse {
  results: ThreadSearchResult[];
}

const MIN_QUERY_LENGTH = 2;
const DEFAULT_LIMIT = 10;

export async function searchThreadsBySubject(
  q: string,
  limit: number = DEFAULT_LIMIT
): Promise<Result<ThreadSearchResult[], ApiError>> {
  const trimmed = q?.trim() ?? '';
  if (trimmed.length < MIN_QUERY_LENGTH) {
    return ok([]);
  }

  try {
    const params = new URLSearchParams({ q: trimmed, limit: String(limit) });
    const response = await axios.get<ThreadSearchResponse>(
      `email/threads/search?${params.toString()}`
    );
    const results = response.data?.results ?? [];

    return ok(Array.isArray(results) ? results : []);
  } catch (error) {
    captureException(error, { functionName: 'searchThreadsBySubject' });

    if (!isAxiosError(error)) {
      return err({ message: 'Failed to search threads by subject' });
    }

    const status = error.response?.status;
    const message =
      (error.response?.data as { message?: string })?.message ||
      'Failed to search threads by subject';

    if (status === 400) {
      return err({ message: 'Invalid search parameters' });
    }
    if (status === 401) {
      return err({ message: 'Unauthorized' });
    }

    return err({ message });
  }
}
